/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';
import { buildFeatureConfigRequestHeaders } from '../../utils/featureConfigUtils';

export default class GetFeatureConfigService extends BaseService {
  constructor() {
    super(constants.GET_FEATURE_CONFIG, 'featureConfigStatus');
  }

  async handleEvent(eventName, event) {
    const { tenantId, tenantKey } = event.payload || {};
    if (!tenantId || !tenantKey) {
      return null;
    }

    const { isStackB } = utils.getStackBParams();
    let headers = await buildFeatureConfigRequestHeaders(tenantId, tenantKey);

    if (isStackB) {
      headers = await utils.resolveStackBHeaders(headers);
    }

    return this.getClient('berlin').get(constants.FEATURE_CONFIG_FETCH_ENDPOINT, {
      headers,
      timeout: constants.BERLIN_API_TIMEOUT
    });
  }

  handleResponse(response) {
    const { data } = response;
    const featureConfigModel = Framework.getStoreRegistry().getStore('featureConfigModel');

    if (data?.featureConfig != null) {
      featureConfigModel?.setConfig?.(data.featureConfig);
    } else if (data?.success === false) {
      featureConfigModel?.setError?.(data.error || data.message || 'Failed to fetch feature config');
    } else if (data && typeof data === 'object' && !Array.isArray(data)) {
      featureConfigModel?.setConfig?.(data);
    }
  }

  handleError(error) {
    const featureConfigModel = Framework.getStoreRegistry().getStore('featureConfigModel');
    const { response } = error;

    if (response) {
      const { data } = response;
      featureConfigModel?.setError?.(data?.error || data?.message || 'Failed to fetch feature config');
    } else if (error.message === 'timeout of 60000ms exceeded') {
      featureConfigModel?.setError?.('Request timeout. Please try again.');
    } else {
      featureConfigModel?.setError?.(error.message || 'Failed to fetch feature config');
    }
  }
}
